import { Component, Input, OnInit } from '@angular/core';
import * as XLSX from 'xlsx';
import { from, Subject } from 'rxjs';
import { APIService } from 'src/app/api.service';
import { CommonService } from 'src/app/services/common.service';
import { ArrayType } from '@angular/compiler';
import { NgxSpinner } from 'ngx-spinner';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

type AOA = any[];

@Component({
  selector: 'app-import-items',
  templateUrl: './import-items.component.html',
  styleUrls: ['./import-items.component.scss']
})
export class ImportItemsComponent implements OnInit {

  @Input() mdlRef: any;


  ItemType: any = [
    {
      id: 1,
      type: "Products"
    },
    {
      id: 2,
      type: "Materials"
    },
    {
      id: 3,
      type: "Spares"
    },
    {
      id: 4,
      type: "Assemblies"
    }
  ];
  
  PurchageTypes: any = [
    {
      id: 1,
      type: "Make"
    },
    {
      id: 2,
      type: "Purchase"
    },
    {
      id: 3,
      type: "Both"
    },   
  ];

  constructor(private apiService: APIService, public CmnService: CommonService, private modalService: NgbModal) {}

data: any = {

}

  storeBatches: any = [{}];
  Stores : any = [];
  ItemCategories : any = [];
  itemList : any = [];
  Units : any = [];
  igonrDup : boolean = false;
  jarvisData: any = [];
  agencyData: any = [];
  HID : any = 0;
  ERP_Agn: Array<any> = [];
  acctStartDT: any = new Date();
  error: any = {
    showError: false,
    removeError: false,
    apiResponse: false
  };
  HSNList: string = "";
  isEnableBatches: boolean = false;
  items: any = [];
  modalReference: any;
  closeResult: any;
  
  impNotesTitle: string = "Important Notes";
  impNotesShowActBtn: boolean = false;

  isWeb: boolean = true;

  ngOnInit(): void {
   
    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }
    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }

    
    // Get cfg data
    this.getErpCfgData();
    
    //Item List
    this.apiService.getIDB('erp_inv', (itemData: any) => {
      if (itemData && itemData.length > 0) {
        this.items = itemData;
      }
    });

    let tmpERP_Agn = this.apiService.getCookie("ERP_Agn");
    if (tmpERP_Agn) {
      this.ERP_Agn = JSON.parse(tmpERP_Agn);
    }

    if (this.ERP_Agn.length > 0) {
      this.acctStartDT = new Date(this.ERP_Agn[0].AccountStartDT);
      this.isEnableBatches = this.ERP_Agn[0].EnblBatches;
    }

    this.isWeb = this.apiService.apiCheckWeb();
  }

  // Get the data from ERP_Cfg cookie
  getErpCfgData () {
    var erpCfgCookie = this.apiService.getCookie("ERP_Cfg");
    
    if (erpCfgCookie) {
      let erpCfgData = JSON.parse(erpCfgCookie);
      
      // Get Store List
      this.Stores = erpCfgData[0].Stores;

      // Get HSN List
      let hsn = erpCfgData[0].HSNSAC;
      if (hsn.length > 0){
        this.HSNList = hsn;
      } 

      //Get Item Categories
      this.ItemCategories = erpCfgData[0].ItemCategories;

      // Get Item UnitList
      this.Units = erpCfgData[0].Units
    }
  }

  //checkExcelColumnHeader() - Check for Excel page
  checkExcelColumnHeader(columnName: string){
    let columnHeaderArray: Array<any> = ["Item Name", "Code", "Category", "Sub-Category", "Type", "Std Cost", "Purch Cost", "Std Sale Price", "Initial Qty", "Unit", "Store", "HSN/SAC", "GST %", "Description", "Source", "Lead Time", "Min. Stock", "MRP Price"];
    if (columnHeaderArray.findIndex((x: any) => x == columnName) > -1) {
        return true;
    }
    else {
        return false;
    }
  }
  
  // Import File
  fileName: string = 'SheetJS.xlsx';

  onFileChange(evt: any) {
    this.closeImpNotesModal('direct');
    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];
      
      // Check for Header column
      let columnsArray: any = XLSX.utils.sheet_to_json(wb.Sheets[wsname], { header: 1 })[0];
      let isErrorForColumn:boolean = false;
      for (var i = 0; i < columnsArray.length; i++) {
        let isOkay = this.checkExcelColumnHeader(columnsArray[i]);  
          if (isOkay == false) {
              isErrorForColumn = true;
              break;
          }
      }

      if (isErrorForColumn == true) {
          this.apiService.successAlert("It seems that the downloaded import templated has been changed.  Please download it again and try to import the data again.");
         return;
      }

      /* save data */
      this.data = <AOA>(XLSX.utils.sheet_to_json(ws));

      // let emtyObj: any = this.data.filter((x: any) => Object.keys(x).length === 0 && x.constructor === Object);
      // console.log("Bank Array Length", emtyObj)
      // if(emtyObj.length > 0){
      //   alert("Please remove all empty rows from the sheet and upload again.");
      //   this.closeModal();
      //   return;
      // }

      this.checkitemValidation(this.data);
      // console.log("Final Data", this.data);
      if(this.itemList.length > 0){
        this.openItemImportErr();
          // this.error.showError = true;
          // this.error.removeError = false;
          // $('.modal-dialog').attr('style', 'min-width: 50% !important');
          // return;
      }
      else{
        this.error.showError = false;
        this.error.removeError = true;
        this.saveBulkItems()
      }
    };
    reader.readAsBinaryString(target.files[0]);
  }
  
  //checkitemValidation() - Check import items validation
  checkitemValidation(items: Array<any>){
    this.getErpCfgData();
     let erroList : Array<any> = [];
     let itmArraylength = items.length;
     let isCheckDup = [];
     let itemType: Array<any> = this.ItemType;
     let PurchageTypes: Array<any> = this.PurchageTypes;

     // StoreList
     let storeList: Array<any> = [];
     storeList = JSON.parse(this.Stores);     

     //Cat-Sub Cat List
     let ItemCategories: Array<any> = [];
     ItemCategories = JSON.parse(this.ItemCategories);

    // UnitList
    let UnitList: Array<any> = [];
    UnitList = JSON.parse(this.Units);

    // HSN List
    let HSNList: Array<any> = [];
    HSNList = JSON.parse(this.HSNList);

    let accountFinYear = this.CmnService.getCurrentFinancialYear(this.acctStartDT);
    let currFinYear = this.CmnService.getCurrentFinancialYear(new Date);

    //Validation
    items.forEach((e: any) => {    
      e.errID = []; //(ID: errorName) 1: itemName, 2: Code, 3: category, 4: sub-category, 5: type, 6: stdCost, 7: purchCost, 8: stdSalePrice, 9: initialQty, 10: unit, 11: store, 12: HSN/SAC, 13: GST, 14: Description, 15: Source, 16: leadTime, 17: minStock
      e.errors = [];
      e.showSettings = false;

      if(!e["Item Name"]){
        e["Item Name"] = '';
      }

      if(!e["Code"]){
        e["Code"] = '';
      }

      if(!e["Category"]){
          e["Category"] = '';
      }

      if(!e["Sub-Category"]){
        e["Sub-Category"] = '';
      }

      if(!e["Type"]){
        e["Type"] = '';
      }

      if(!e["Unit Price"]){
        e["Unit Price"] = '';
      }

      if(!e["Initial Qty"]){
        e["Initial Qty"] = 0;
      }

      if(!e["Unit"]){
        e["Unit"] = '';
      }
      
      
      if(!e["Store"]){
        e["Store"] = '';
      }

      // if(!e["Unit Price"]){
      //     e["Unit Price"] = 0;
      // }

      if(!e["Std Cost"]){
        e["Std Cost"] = '0';
      }
      
      if(!e["Purch Cost"]){
        e["Purch Cost"] = '0';
      }
      if(!e["Std Sale Price"]){
        e["Std Sale Price"] = '0';
      }

      if(!e["HSN/SAC"]){
          e["HSN/SAC"] = '';
      }

      if(!e["GST %"]){
          e["GST %"] = 0;
      }

      if(!e["Description"]){
        e["Description"] = '';
      }

      if(!e["Source"]){
        e["Source"] = '';
      }

      if(!e["Lead Time"]){
        e["Lead Time"] = 0;
      }
      
      if(!e["Min. Stock"]){
        e["Min. Stock"] = 0;
      }

      if(!e["MRP Price"] || String(e["MRP Price"]).trim() == ''){
        e["MRP Price"] = 0;
      }

      e["Item Name"] = String(e["Item Name"]).trim();
      e["Code"] = String(e["Code"]).trim();
      e["Store"] = String(e["Store"]).trim();
      e["Category"] = String(e["Category"]).trim();
      e["Sub-Category"] = String(e["Sub-Category"]).trim();
      e["Unit"] = String(e["Unit"]).trim();
      e["Type"] = String(e["Type"]).trim();
      e["HSN/SAC"] = String(e["HSN/SAC"]).trim();

      if(e["Item Name"] == '') {
        e.errID.push(1);
        e.errors.push({ errID: 1, errorMsg: 'Please enter an item name.' });
      }
      else if (e["Item Name"].length > 100) {
        e.errID.push(1);
        e.errors.push({ errID: 1, errorMsg: 'Please enter item name shorter than 100 characters.' });
      }
      else {
      	//Item Name Duplications in Excel
        isCheckDup = $.grep(items, function(o: any){ return o["Item Name"] == e["Item Name"]});
        if(isCheckDup.length > 1){
            e.errID.push(1);
            e.errors.push({ errID: 1, errorMsg: 'Duplicate item name in uploaded sheet.' });
        }
        else{
          // Check Duplicate item in item List
          let isDup = this.items.filter((x: any) => x.ItemName == e["Item Name"])
          if(isDup.length > 0){
            e.errID.push(1);
            e.errors.push({ errID: 1, errorMsg: 'Another item with this name already exists.' });
          }
        }                
      }
      // Item Code Duplications in excel
      if(e["Code"] == '') {
        e.errID.push(2);
        e.errors.push({ errID: 2, errorMsg: 'Please enter an item code.' });
      }
      else if (e["Code"].length > 50) {
        e.errID.push(2);
        e.errors.push({ errID: 2, errorMsg: 'Please enter item code shorter than 50 characters.' });
      }
      else{
        isCheckDup = [];
        isCheckDup = $.grep(items, function(o: any){ return o.Code == e.Code});
        if(isCheckDup.length > 1){
            e.errID.push(2);
            e.errors.push({ errID: 2, errorMsg: 'Duplicate item code in uploaded sheet.' });
        }
        else{
          // Check Duplicate item code in item List
          let isDup = this.items.filter((x: any) => x.ItemCode == e.Code)
          if(isDup.length > 0){
            e.errID.push(2);
            e.errors.push({ errID: 2, errorMsg: 'Another item with this code already exists.' });
          }
        }         
      }
       
      //Item Store
      if(e.Store == '' && e["Initial Qty"] > 0){
        e.errID.push(11);
        e.errors.push({ errID: 11, errorMsg: 'Please enter a store.' });
      }
      else {
        if(e.Store == '' && !e["Initial Qty"]){
          e.storeID = 0;
        }
        else {
          isCheckDup = [];
          isCheckDup = storeList.filter((x:any)=>x.sNm.toLowerCase() == e.Store.toLowerCase());
          //isCheckDup = $.grep(storeList, function(o: any){ return o.sNm == e.Store});
          if(isCheckDup.length == 0){
            e.errID.push(11);
            e.errors.push({ errID: 11, errorMsg: 'Please enter a valid store.' });
          }
          else{
            e.storeID = isCheckDup[0].StrID;
            e.Store = isCheckDup[0].sNm;
          }
        }        
      }
  
      //Item Category & SubCat
      if(e['Category'] == '') {
        e.errID.push(3);
        e.errors.push({ errID: 3, errorMsg: 'Please enter a category.' });
      }
      isCheckDup = [];
      isCheckDup = $.grep(ItemCategories, function(o: any){ return o.cnm.toLowerCase() == e.Category.toLowerCase()});
      if(isCheckDup.length == 0){
        e.errID.push(3);
        e.errors.push({ errID: 3, errorMsg: 'Please enter a valid category.' });
      }
      else {
        e.CID = isCheckDup[0].cid;
        e.Category = isCheckDup[0].cnm;

        // for Sub-Category Validation
        if(isCheckDup[0].sub) {
          if(e["Sub-Category"] == ''){
            e.errID.push(4);
            e.errors.push({ errID: 4, errorMsg: 'Please enter a valid sub-category.' });
          }
          else{
            let subCategory = isCheckDup[0].sub;
            isCheckDup = $.grep(subCategory, function(o: any){ return o.snm.toLowerCase() == e["Sub-Category"].toLowerCase()});
            if(isCheckDup.length > 0){
              e.SCID = isCheckDup[0].sid;
              e["Sub-Category"] = isCheckDup[0].snm;
            }
            else{
              e.errID.push(4);
              e.errors.push({ errID: 4, errorMsg: 'Please enter a valid sub-category.' });
            }
          }        
        }
        else{
          e.errID.push(4);
          e.errors.push({ errID: 4, errorMsg: 'Please enter a valid sub-category.' });
        }
      }

      if(e["GST %"] == "undefined" || e["GST %"] == null || isNaN(e["GST %"]) == true){
        e.errID.push(13);
        e.errors.push({ errID: 13, errorMsg: 'Please enter the GST rate.' });
      }
      else{
        if(!e["HSN/SAC"] && e["GST %"] > 0){
          e.errID.push(12);
          e.errors.push({ errID: 12, errorMsg: 'Please enter the HSN/SAC.' });
        }
      }
    
      if(e["HSN/SAC"]){
        isCheckDup = [];
        isCheckDup = $.grep(HSNList, function(o: any){ return o.H == String(e["HSN/SAC"]).trim()});
        if(isCheckDup.length > 0){
          e.HSNID = isCheckDup[0].HID;
          e["GST %"] = isCheckDup[0].Per;
        }
        else{
          e.HSNID = 0;
        }
      }
      else{
        e.HSNID = 0;
      }

      //Item Unit List
      if(e['Unit'] == ''){
        e.errID.push(10);
        e.errors.push({ errID: 10, errorMsg: 'Please enter a unit.' });
      }
      else{
        isCheckDup = [];
        isCheckDup = $.grep(UnitList, function(o: any){ return o.UNm.toLowerCase() == e.Unit.toLowerCase()});
        if(isCheckDup.length == 0){
          e.errID.push(10);
          e.errors.push({ errID: 10, errorMsg: 'Please enter a valid unit.' });
        } 
        else {
          e.Unit = isCheckDup[0]?.UNm;
        }
      }
      // // Unit Price
      // if(e["Unit Price"] == "undefined" || e["Unit Price"] == null || isNaN(e["Unit Price"]) == true){
      //   e.errorMsg = e.errorMsg + 'Please enter the unit price. '
      // }
      // else if(e["Unit Price"] < 0){
      //   e.errorMsg = e.errorMsg + 'Please enter a valid unit price. '
      // }

      // Std Cost
      if(e["Std Cost"] == "undefined" || e["Std Cost"] == null || isNaN(e["Std Cost"]) == true || e["Std Cost"] < 0){
        e.errID.push(6);
        e.errors.push({ errID: 6, errorMsg: 'Please enter a valid std cost.' });
      }

      // Purch Cost
      if(e["Purch Cost"] == "undefined" || e["Purch Cost"] == null || isNaN(e["Purch Cost"]) == true || e["Purch Cost"] < 0){
        e.errID.push(7);
        e.errors.push({ errID: 7, errorMsg: 'Please enter a valid purch price.' });
      }

      // Std Sale Price
      if(e["Std Sale Price"] == "undefined" || e["Std Sale Price"] == null || isNaN(e["Std Sale Price"]) == true || e["Std Sale Price"] < 0){
        e.errID.push(8);
        e.errors.push({ errID: 8, errorMsg: 'Please enter a valid std sale price.' });
      }

      //Item Initial Qty 
      if(e["Initial Qty"] == "undefined" || e["Initial Qty"] == null || isNaN(e["Initial Qty"]) == true || e["Initial Qty"] < 0) {
        e.errID.push(9);
        e.errors.push({ errID: 9, errorMsg: 'Please enter a valid initial item quantity.' });
      }
      else if(accountFinYear != currFinYear && e["Initial Qty"] > 0){
        e.errID.push(9);
        e.errors.push({ errID: 9, errorMsg: 'Initial quantity cannot be entered after the first financial year.' });
      }
      else if(e["Initial Qty"] > 0){
        let selectedUnit = $.grep(UnitList, function(o: any){ return o.UNm == e.Unit});
        if(selectedUnit.length > 0){
            let precisonNum = selectedUnit[0].Prcsn;
            let initialQtyPrcsn = String(e["Initial Qty"]).split(".");
            if(initialQtyPrcsn.length > 1){
              let selectedPrcn = String(initialQtyPrcsn[1]).length;
              if(precisonNum < selectedPrcn && selectedPrcn > 0){
                e.errID.push(9);
                e.errors.push({ errID: 9, errorMsg: 'Initial quantity precision do not match with unit precision.' });
              }
            }
        }
      }
      //Type
      if(e["Type"] == ''){
        e.errID.push(5);
        e.errors.push({ errID: 5, errorMsg: 'Please enter an item type.' });
      }
      else{
        isCheckDup = [];
        isCheckDup = $.grep(itemType, (o: any) => { return o.type.toLowerCase() == e.Type.toLowerCase()});
        if(isCheckDup.length == 0){
          e.errID.push(5);
          e.errors.push({ errID: 5, errorMsg: 'Please enter a valid type.' });
        }
        else{
          e.typeID = isCheckDup[0].id;
          e.Type = isCheckDup[0].type;
        }
      }

      //Source
      if(e.Source){
        isCheckDup = [];
        isCheckDup = $.grep(PurchageTypes, (o: any) => { return o.type.toLowerCase() == e.Source.toLowerCase()});
        if(isCheckDup.length == 0){
          e.errID.push(15);
          e.errors.push({ errID: 15, errorMsg: 'Please enter a valid sourcing method.' });
        }
        else{
          e.purchageTypeID = isCheckDup[0].id;
          e.Source = isCheckDup[0].type;
        }
      }
    
      //Description
      if(e.Description){
        e.Description = String(e.Description).trim();
        if(e.Description.length > 300){
          e.errID.push(14);
          e.errors.push({ errID: 14, errorMsg: 'Please enter a description shorter than 300 characters.' });
        }    
      }
    
      //Lead Time
      if(e["Lead Time"] == "undefined" || e["Lead Time"] == null || isNaN(e["Lead Time"]) == true || e["Lead Time"] < 0){
        e.errID.push(16);
        e.errors.push({ errID: 16, errorMsg: 'Please enter a valid lead day.' });
      }

      //Minimum Stock
      if(e["Min. Stock"] == "undefined" || e["Min. Stock"] == null || isNaN(e["Min. Stock"]) == true || e["Min. Stock"] < 0){
        e.errID.push(17);
        e.errors.push({ errID: 17, errorMsg: 'Please enter a valid minimum stock quantity.' });
      }


      // MRP Price
      if(e["MRP Price"] == "undefined" || e["MRP Price"] == null || isNaN(e["MRP Price"]) == true || e["MRP Price"] < 0){
        e.errID.push(18);
        e.errors.push({ errID: 18, errorMsg: 'Please enter a valid MRP Price.' });
      }

      if (e.errors.length > 0) {
        if(e.errors[0].errorMsg.trim() == 'Please enter a valid category.' || e.errors[0].errorMsg.trim() == 'Please enter a valid sub-category.') {
          e.showSettings = true;
        }
      }

    // // Split the string into sentences based on the period
    // let sentences = e.errorMsg.split('.').map((sentence: any) => sentence.trim()).filter((sentence: any) => sentence);

    // // Create bullet points using the Unicode character for bullet and newline character for each sentence
    // e.errorMsg = sentences.map((sentence: any) => `\u2022 ${sentence}`).join('. \n');

  });

    for(let i: number = 0; i < itmArraylength; i++){
      if(items[i]?.errors && items[i]?.errors.length > 0 || items[i].ErrorMsg){
        let errMsg = items[i].errors || items[i].ErrorMsg;
        erroList.push({
          errID: items[i].errID,
          errors: errMsg,
          msg: errMsg,
          showSettings: items[i].showSettings
        });
      }
    }
    this.itemList = erroList;
    localStorage.setItem('importItems', JSON.stringify(items));
  }
  
  //Check Duplicate in XCSL file..
   toFindDuplicates(items: Array<any>, property: string) {
      const lookup = items.reduce((a, e) => {
        a[e[property]] = ++a[e[property]] || 0;
        return a;
      }, {});

      let duplicateNames = items.filter(e => lookup[e[property]]);
      return duplicateNames;
   }

  //Close Model 
  closeModal() {
    this.mdlRef.close();
  }

  //saveBulkItems() - Add excel data into database
  saveBulkItems(){
    let finalItemArry:Array<any> = [];
    if(this.error.removeError == true){
      this.data.forEach(function (e: any){
        if(e.errors == ''){      
        
          let DefStockRate: String = ((!e["Std Cost"] || e["Std Cost"] == 0) ? 0 : String(e["Std Cost"]).trim()) + "";
          let DefPurchRate: String = ((!e["Purch Cost"] || e["Purch Cost"] == 0) ? DefStockRate : String(e["Purch Cost"]).trim()) + "";
          let DefSaleRate: string = ((!e["Std Sale Price"] || e["Std Sale Price"]  == 0) ? DefStockRate : String(e["Std Sale Price"]).trim()) + "";
          
            finalItemArry.push({
              'ItemID': 0,
              'ItemName': String(e["Item Name"]).trim(),
              'ItemCode': String(e.Code).trim(),        
              'Details': e.Description ? String(e.Description).trim() : '',
              'TypeID': String(e.typeID).trim(),
              'CategoryID': String(e.CID).trim(),
              'SubCategoryID': String(e.SCID).trim(),
              'ISMade': (e.purchageTypeID == 1 || e.purchageTypeID == 3) ? 1 : 0,
              'IsPurchased': (e.purchageTypeID == 2 || e.purchageTypeID == 3) ? 1 : 0,      
              'CurrQty': String(e["Initial Qty"]).trim() + "",
              'CurrStoreID': String(e.storeID).trim(),
              'SKU': String(e.Unit).trim(),
              'storeBatches': '',
              'DefPurchRate': DefPurchRate + "",
              'DefSaleRate': DefSaleRate + "",
              'DefStockRate': DefStockRate + "",
              'MinStockQty': (!e["Min. Stock"] ? 0 : String(e["Min. Stock"]).trim()) + "",
              'IsAvailable': 1,
              'IsActive': 1,
              'ImportanceID': 1,
              'HSNID': e.HSNID,
              'ShowOnline': 1,
              'BrochureLink': '',
              'photos': '',
              'Tags': '',
              'LeadTime': (!e["Lead Time"] ? 0 : String(e["Lead Time"]).trim()) + "",
              'HsnNo': (!e["HSN/SAC"] ? 0 : String(e["HSN/SAC"]).trim()) + "",
              'IGSTRate': (!e["GST %"] ? 0 : String(e["GST %"]).trim()) + "",
              'InternalNotes': '',
              'MRPPrice': (!e["MRP Price"] ? '0' : String(e["MRP Price"] ).trim())
            });
        }
      });
    }
    
    if(finalItemArry.length == 0){
      this.apiService.successAlert("No data found.");
      this.closeModal();
      return;
    }

    let itemCnt = finalItemArry.length;
    

    let isAllowConfirm = confirm("Are you sure you want to import "+ itemCnt +" " + (itemCnt > 1 ? 'items' : 'item') + " ?");
    if(!isAllowConfirm){
      return;
    }  

    let MyLastSyncDT = localStorage.getItem("MyLastSyncDT")

    let data = [{
        data: JSON.stringify(finalItemArry)
    }];

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      myLastSyncDT: MyLastSyncDT,
      isWeb: true,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      actionType: 'importItems',
      moduleID: 5,
      data: JSON.stringify(data)
    }];

    this.apiService.sendChangeForm(myParams, this.successItemEntry.bind(this), this.failureResp.bind(this));
  }

     //successVchrEntry - success voucher entry handler
     successItemEntry(res: any) {
      this.error.apiResponse = true;
      if (res.error) {
      }
      else {
        this.itemList = [];
        let erroList: Array<any> = [];
          if (res.updatePackage) {
              let result: any = JSON.parse(res.updatePackage);
              let returnItems = result.Table1;
              if(returnItems.length > 0){
                for(let i: number = 0; i < returnItems.length; i++){
                  if((returnItems[i]?.errors && returnItems[i]?.errors.length > 0) || returnItems[i].ErrorMsg){
                    let errMsg = returnItems[i].errors || returnItems[i].ErrorMsg;
                      erroList.push({
                        srNo: i + 1,
                        itemName: returnItems[i].ItemName,
                        errors: errMsg,
                        msg: errMsg
                      });
                  }
                }
                this.error.showError = true;
                this.error.removeError = false;
                this.itemList = erroList;
                $('.modal-dialog').attr('style', 'min-width: 50% !important');
              }
              else{
                this.apiService.successAlert('Items imported.');
                let doneObj = {
                  action: 'Done'
              }
                this.closeModel(doneObj);
              }
            
          }
      }
   }

    //failureResp - failure handler
    failureResp(res: any) {
      if (res.error) {
      }
      else {
        this.apiService.successAlert(res.message);
      }
    }

    closeModel(obj: any) {
      this.mdlRef.close(obj);
    }

    backtoImportScreen(){
      $('.modal-dialog').attr('style', 'min-width: 31% !important');
      this.itemList = [];
      this.error.showError = false;
      this.error.removeError = false;
      this.error.apiResponse = false;
    }

    
    // open() - open edit unit and add new unit modal 
    openModal(mdlID: any, from: any) { 
      if (from == 'fromInfo') {
        this.impNotesTitle = "Important Notes";
        this.impNotesShowActBtn = false;

      } else {
        this.impNotesTitle = "Have you ensured the following?";
        this.impNotesShowActBtn = true;
      }
      this.modalReference = this.modalService.open(mdlID, { ariaLabelledBy: 'modal-basic-title', windowClass: 'impNotesMdl', backdrop: 'static', keyboard: false });
        this.modalReference.result.then((result: any) => {
            this.closeResult = `Closed with: ${result}`;
        },
            (reason: any) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }

    private getDismissReason(reason: any): string {
      if (reason === ModalDismissReasons.ESC) {
          return 'by pressing ESC';
      } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
          return 'by clicking on a backdrop';
      } else {
          return `with: ${reason}`;
      }
    }

    closeImpNotesModal(action: any) {
      if (action == 'alert') {
        this.apiService.successAlert('Please update the excelsheet and try again.');
      }
      this.modalReference.close();
    }

    openItemImportErr() {  
      let urlCheck: string = "";
      if (this.apiService.fn_isLiveURL() == true) {
        urlCheck = "/ERP";
      }
      urlCheck += "/ImportItems"; 
      
      let target: string = "_blank";
      if(this.isWeb == false){
        target = "_self";
      }
      window.open(urlCheck, target);
    }
}
